// Error code → Spanish UI string. Strings are LOCKED verbatim from UI-SPEC.

const ERROR_MESSAGES: Record<string, string> = {
  'origin-not-allowed': 'Hubo un error al enviar tu mensaje. Intenta de nuevo en unos minutos.',
  'cannot-determine-ip': 'No pudimos verificar tu conexión. Revisa tu red e intenta de nuevo.',
  'too-many-requests':
    'Has enviado demasiadas solicitudes. Espera un minuto antes de volver a intentar.',
  'invalid-json': 'Hubo un error al enviar tu mensaje. Intenta de nuevo en unos minutos.',
  'invalid-payload': 'Revisa los campos marcados y vuelve a intentar.',
  'captcha-failed': 'No pudimos validar tu desafío. Vuelve a intentar.',
  'persistence-failed': 'Hubo un error al enviar tu mensaje. Intenta de nuevo en unos minutos.',
  'payload-too-large': 'El mensaje es demasiado largo. Intenta acortarlo.',
  'network-failed': 'Hubo un error al enviar tu mensaje. Intenta de nuevo en unos minutos.',
};

const FALLBACK = 'Hubo un error al enviar tu mensaje. Intenta de nuevo en unos minutos.';

export function errorMessage(code: string, _detail?: string | string[]): string {
  return ERROR_MESSAGES[code] ?? FALLBACK;
}
